export interface KioskCredential {
  password?: string;
  pin?: string;
}

// Use a global Map so the in-memory credential vault survives Vite HMR
// (which can re-execute this module while the KioskSignModal remains loaded
// in an older module instance). This is still process/memory-local and is
// cleared by the supervisor session lifecycle.
const globalStore = globalThis as { __h3ight_kiosk_vault?: Map<string, KioskCredential> };
const vault = globalStore.__h3ight_kiosk_vault ?? new Map<string, KioskCredential>();
if (!globalStore.__h3ight_kiosk_vault) {
  globalStore.__h3ight_kiosk_vault = vault;
}

export function storeKioskCredential(idempotencyKey: string, credential: KioskCredential): void {
  vault.set(idempotencyKey, { ...credential });
}

export function getKioskCredential(idempotencyKey: string): KioskCredential | undefined {
  return vault.get(idempotencyKey);
}

export function clearKioskCredential(idempotencyKey: string): void {
  vault.delete(idempotencyKey);
}

export function hasKioskCredential(idempotencyKey: string): boolean {
  return vault.has(idempotencyKey);
}

/** Test-only helper to reset vault state between cases. */
export function __clearAllKioskCredentials(): void {
  vault.clear();
}
